/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterTestDto } from '../../models/filter-test-dto';
import { ResponseTestDto } from '../../models/response-test-dto';

export interface TestsControllerFilter$Params {
      body: FilterTestDto
}

export function testsControllerFilter(http: HttpClient, rootUrl: string, params: TestsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseTestDto>>> {
  const rb = new RequestBuilder(rootUrl, testsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseTestDto>>;
    })
  );
}

testsControllerFilter.PATH = '/thalea-pathways/tests/filter';
